import { render, staticRenderFns } from "./AlignmentProperties.vue?vue&type=template&id=5ce826b8&scoped=true"
import script from "./AlignmentProperties.vue?vue&type=script&lang=js"
export * from "./AlignmentProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce826b8",
  null
  
)

export default component.exports